export default "__VITE_ASSET__BbH5Yt36__"